import script from "./TbOrderCleanView.vue?vue&type=script&setup=true&lang=js"
export * from "./TbOrderCleanView.vue?vue&type=script&setup=true&lang=js"

import "./TbOrderCleanView.vue?vue&type=style&index=0&id=7d1df526&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d1df526"]])

export default __exports__